import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { Alert, Card, Empty, PageHeader, Spinner } from '../components/ui';
import { useCachedOpenSessions } from '../count/sessionCache';
import { dt } from '../lib/format';

export default function CountIndexPage() {
  const { can } = useAuth();
  const list = useCachedOpenSessions();
  return (
    <>
      <PageHeader title="นับสินค้า" subtitle="เลือกรอบการนับที่เปิดอยู่" />
      {list.offline && (
        <div className="mb-3">
          <Alert tone="info">ออฟไลน์ — แสดงรายการรอบที่เก็บไว้ในเครื่องจากครั้งล่าสุดที่ออนไลน์</Alert>
        </div>
      )}
      {list.error && <Alert>{list.error.message}</Alert>}
      {!list.data && !list.error && <Spinner />}
      {list.data?.total === 0 && (
        <Empty>
          ยังไม่มีรอบการนับที่เปิดอยู่
          {can('sessions.manage') && (
            <>
              {' — '}
              <Link to="/sessions" className="text-brand underline">
                สร้างรอบการนับ
              </Link>
            </>
          )}
        </Empty>
      )}
      <div className="grid gap-3 sm:grid-cols-2">
        {list.data?.data.map((s) => (
          <Link key={s.id} to={`/count/${s.id}`} className="block">
            <Card className="h-full hover:border-brand">
              <div className="text-sm text-muted">{s.session_code}</div>
              <div className="text-xl font-bold">{s.warehouse_code}</div>
              <div>{s.warehouse_name}</div>
              <div className="mt-2 text-sm text-muted">
                {s.item_count.toLocaleString()} สินค้า · {s.entry_count.toLocaleString()} ครั้ง · เปิดเมื่อ {dt(s.created_at)}
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </>
  );
}
